<style scoped lang="scss">
    @import "../../../styles/var";

    .main {
        padding: 0 20px;
        margin: -30px -20px;
    }

    .list {
        overflow-x: auto;

        li {
            border-radius: 4px;
            margin-right: 10px;
            padding: 10px;
            border: 1px solid $bgColor;
        }

        li.cover {
            overflow: hidden;
            border: 1px solid $mainColor;
            background-image: url("../../../assets/icon/选中.png");
            background-size: 20px 20px;
            background-repeat: no-repeat;
            background-position: right bottom;
        }
    }
</style>
<template>
    <el-dialog title="请在HIS中为患者" :visible.sync="showTag">
        <div class="main">
            <p class="flex aic fs14 color_666">
                <span>{{info.commpatName||info.compatName}}</span>
                <span class="ml5">{{info._sex}}</span>
                <span class="ml5" v-if="info.commpatAge||info.compatAge">
                    {{info.commpatAge||info.compatAge}}岁
                </span>
                <span class="ml10">
                    就诊卡号：{{info.commpatMedicalRecord||info.compatHosCardId}}
                </span>
            </p>
            <p class="mt10 fs16">开好处方、调整用法用量（如有需要）</p>
            <div class="list pt10 pb10">
                <ul class="flex">
                    <li class="flex0 pointer" :class="{cover:inList(o.orderNo)}" v-for="(o,i) in list" :key="i"
                        @click="handler(o)">
                        <div class="flex color_999 fs12">
                            <span>处方单号：</span>
                            <span>{{o.orderNo}}</span>
                        </div>
                        <div class="flex color_999 fs12 mt5">
                            <span>处方日期：</span>
                            <span>{{o.createDate|formateTime}}</span>
                        </div>
                        <div class="flex color_999 fs12 mt5">
                            <span>处方医生：</span>
                            <span>{{o.docName}}</span>
                            <span class="ml5">处方科室：</span>
                            <span>{{o.deptName}}</span>
                        </div>
                        <!--<div class="flex color_999 fs12 mt5">
                            <span>诊断：</span>
                            <span>{{o.disname}}</span>
                        </div>-->
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer" class="dialog-footer ">
            <el-button size="mini" @click="hide">取 消</el-button>
            <el-button size="mini" type="primary" @click="agree">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {timeFormat} from "../../../lib/utils";

  export default {
    name: "his-agree-dialog",
    props: {
      list: Array,
      info: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        prescriptionNoList: [],
        showTag: false
      }
    },
    filters:{
        //时间的格式化函数
        formateTime(value){
            return timeFormat(value,'%Y-%m-%d');
        },
    },
    methods: {
      show() {
        this.prescriptionNoList.splice(0);
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      },
      inList(orderNo) {
        return this.prescriptionNoList.includes(orderNo);
      },
      handler(data) {
        let index = this.prescriptionNoList.indexOf(data.orderNo);
        if (index >= 0) {
          this.prescriptionNoList.splice(index, 1);
        } else {
            this.prescriptionNoList.push(data.orderNo);
        }
      },
      async agree() {
        const {prescriptionNoList} = this;
        if (prescriptionNoList.length === 0) return this.$message.error('请选择至少一个处方');
        const orderNo = prescriptionNoList[0];
        const {disname: previousPrescriptionDiagnosis = ''} = this.list.find(r => r.orderNo === orderNo);
        this.hide();
          // 判断原处方信息来源是
          // bizType:
          // 复诊续方-CONSULT_CONTINUATION
          // 拍照续方-CONTINUATION_PRESCRIPTION
          // 网络诊间-ONLINE_OUTPATIENT
          // 科室咨询-PLATFORMPIC
          // 图文咨询-CONSULT_PIC
          // 视频咨询-CONSULT_VIDEO

          this.$emit('agree', '同意his处方', {
            bizId: this.info.id,
            // bizType: 'CONTINUATION_PRESCRIPTION', //慢病续方
            orderNos: prescriptionNoList,
            bookHosId: this.list[0].hosId,
            compatId: this.info.compatId
            // previousPrescriptionDiagnosis
        });
      }
    },
  }
</script>
